import APIS from '../../module/apis'
import monitor from 'src/frontend-lib/lib/monitor'

import { axios as $http, setHeader } from 'cm'
import { loadScript } from '../../../../../public-resource/libs/utils/index'

// import md5 from '../../../../../public-resource/libs/md5/md5'

// unused params
// const ua = window.navigator.userAgent.toUpperCase()
// const isMqqBrowser =
//   ua.indexOf('MQQBROWSER') !== -1 && ua.indexOf('MOBILE MQQBROWSER') === -1

const loadPolyv = vid =>
  new Promise((resolve, reject) => {
    // if (isMqqBrowser) {
    //   return reject()
    // }
    // loadScript('//player.polyv.net/script/player.js', () => {
    const userAgent = navigator.userAgent
    const scriptUrl =
      userAgent.indexOf('AlipayClient') > -1
        ? '//player.polyv.net/resp/vod-player/latest/player.js'
        : '//player.polyv.net/script/player.js'
    loadScript(scriptUrl, () => {
      // loadScript('https://player.polyv.net/script/player.js', () => {
      const { is_video, audio, player } = window.baseInfo
      const config = is_video === 0 ? audio : player
      console.log('js loaded', config)
      // $http('http://49swtt.natappfree.cc/polyv/token?id=' + vid)
      //   .then(res => {
      //     resolve(res.data.data.data)
      //   })
      resolve({
        ts: config.ts,
        playsafe: config.token,
        sign: config.hash,
        // flashvars: {
        //   loading_bg_img: config.cover
        // },
        loading_bg_img: config.cover,
        forceH5: true
      })
    })
  })

const noop = () => {}

/**
 * @param el [element]
 */
function playInit(el) {
  const { is_video, audio, player, play_time } = window.baseInfo
  const vid = is_video === 0 ? audio.vid : player.vid
  const onError = e => {
    console.log('play error 播放错误', e)
    if (monitor) {
      monitor.stat({
        logType: 'info',
        title: '学院-错误日志',
        message: JSON.stringify({
          keshi_id: window.baseInfo.keshi_id,
          session_id: window.baseInfo.user_id,
          错误信息: e
        }),
        level: 'error',
        url: location.href,
        payParameters: JSON.stringify({}),
        code: '',
        UA: navigator.userAgent,
        remark: '课程播放页面 - 播放错误'
      })
    }
    // el.innerText = '不支持该浏览器播放，请下载app观看'
  }
  const playStat = () => {
    console.log('maidian')
    let classify =
      +window.baseInfo.is_experience === 1
        ? '免费试听'
        : +window.baseInfo.is_free === 1
        ? '免费课程'
        : '付费课程'
    window.yxl.stat.send({
      name: '课程-播放页「播放按钮」点击',
      properties: {
        课程类型: classify,
        课程名称: window.baseInfo.lesson_title
      }
    })
  }

  const playerEvent = obj => {
    const { error, play, pause, stop, seek, serverError } = obj
    let played = false
    // play: (event, played) => {
    //   if (!played) {
    //     playStat()
    //     player.j2s_seekVideo(play_time ? parseInt(play_time) : 0)
    //   }
    //   postTime()
    // },
    const _play = event => {
      played = true
      play(event, played)
    }
    window.s2j_onVideoPlay = _play
    window.s2j_onVideoPause = pause
    window.s2j_onPlayerError = error
    window.s2j_onPlayOver = stop
    window.s2j_onVideoSeek = seek
    window.serverError = serverError
    // window.addEventListener('message', event => {
    //   let { message, config } = event.data;
    //   config = JSON.parse(config)
    //   switch (message) {
    //     case 's2j_onPlayerError':
    //       error(config.name);
    //       break;
    //     case 's2j_onVideoPlay':
    //       _play();
    //       break;
    //     case 's2j_onVideoPause':
    //       pause()
    //       break;
    //     case 's2j_onPlayOver':
    //       stop()
    //       break;
    //     case 's2j_onVideoSeek':
    //       seek()
    //       break
    //   }
    // }, false);
  }

  loadPolyv(vid)
    .then(cfg => {
      let winW = window.innerWidth
      winW = winW > 768 ? 768 : winW
      let winH = (winW * 338) / 600 + ''
      document.querySelector(
        '.video-player-container'
      ).style.height = `${winH}px`

      var config = {
        // wrap: el,s
        width: winW + '',
        height: winH,
        vid: vid,
        session_id: window.baseInfo.user_id, // 用于记录播放进度，统计完课率
        flashvars: { param2: window.baseInfo.user_name.replace(/&/g, '') }, // 用于记录播放进度，统计完课率
        params: { param2: window.baseInfo.user_name.replace(/&/g, '') }, // 用于记录播放进度，统计完课率
        speed: [2, 1.5, 1.2, 1],
        showLine: 'off',
        hideAudioMode: true,
        showHd: true,
        showAuto: true
        // audioMode: false  //隐藏音视频切换参数

        // watchStartTime: play_time ? parseInt(play_time) : 0
      }
      // Object.assign(config, cfg);
      for (let key in cfg) {
        config[key] = cfg[key]
      }
      if (is_video === 0) {
        config.priorityMode = 'audio'
        config.videoMode = false
      }

      // 判断本地缓存中是否有旧的播放时长数据，如果有重置
      window.learnTotalTime = +window.baseInfo.today_learn_time || 0

      console.log('beforeconfig', config)
      // var player = polyvObject('#video-player-container').videoPlayer(config);
      // var player = window.polyvObject(el).videoPlayer(config)
      var player = window.polyvPlayer({
        wrap: el,
        ...config
      })
      console.log('init done', player)
      window.player = player
      return player
    })
    .then(player => {
      playerEvent({
        error: onError, // onError,
        play: (event, played) => {
          console.log('播放+记录时间')
          postTime()
          startTimingEecords()
          if (!played) {
            playStat()
            player.j2s_seekVideo(play_time ? parseInt(play_time) : 0)
          }
          loadingMonitor()
        },
        pause: event => {
          console.log('暂停+记录时间', event)
          closeTimingEecords()
          postTime(undefined, true)
          if (playLoadingInterval) {
            clearInterval(playLoadingInterval)
          }
          playLoadingSeconds = 0
        },
        stop: () => {
          closeTimingEecords()
          postTime(undefined, true)
          if (playLoadingInterval) {
            clearInterval(playLoadingInterval)
          }
          playLoadingSeconds = 0
        },
        seek: () => {
          postTime()
        },
        serverError: e => {
          console.log('serverError 业务逻辑错误', e)
          if (monitor) {
            monitor.stat({
              logType: 'info',
              title: '学院-错误日志',
              message: JSON.stringify({
                keshi_id: window.baseInfo.keshi_id,
                session_id: window.baseInfo.user_id,
                错误信息: e
              }),
              level: 'error',
              url: location.href,
              payParameters: JSON.stringify({}),
              code: '',
              UA: navigator.userAgent,
              remark: '课程播放页面 - 业务逻辑错误'
            })
          }
        }
      })

      // window.onbeforeunload = postTime

      // var time = window.setInterval(postTime, 6000);

      let playTime = window.baseInfo.play_time

      // 记录实际播放时间
      function setLocalLearnTime(isPause) {
        // 如果是第一次记录
        if (!window.learnStartTime) {
          window.learnStartTime = new Date().getTime()
        } else {
          let learnNowTime = window.isPauseTime
            ? window.learnStartTime
            : new Date().getTime()
          // 更新总学习时长(秒)
          window.learnTotalTime = parseInt(
            window.learnTotalTime +
              (learnNowTime - window.learnStartTime) / 1000
          )

          // 更新起始计算时间
          window.learnStartTime = new Date().getTime()
        }

        window.isPauseTime = !!isPause // 如果暂停了就停止计时
        console.log(
          '设置学习时长统计：',
          window.learnTotalTime,
          window.learnStartTime
        )
      }

      // loading过长上报
      var nowTime = ''
      var playLoadingInterval = null
      var playLoadingSeconds = 0
      function loadingMonitor() {
        if (playLoadingInterval) {
          clearInterval(playLoadingInterval)
        }
        nowTime = playTime
        playLoadingInterval = setInterval(() => {
          if (!player) {
            clearInterval(playLoadingInterval)
            return
          }
          const _playTime = player.j2s_getCurrentTime()
          playTime = _playTime || playTime
          if (playTime !== nowTime) {
            playLoadingSeconds = 0
            nowTime = playTime
          } else {
            playLoadingSeconds++
            if (playLoadingSeconds === 5) {
              console.log('loading5秒')
              if (monitor) {
                monitor.stat({
                  logType: 'info',
                  title: '学院-错误日志',
                  message: JSON.stringify({
                    keshi_id: window.baseInfo.keshi_id,
                    session_id: window.baseInfo.user_id,
                    卡顿时间点: playTime
                  }),
                  level: 'error',
                  url: location.href,
                  payParameters: JSON.stringify({}),
                  code: '',
                  UA: navigator.userAgent,
                  remark: '课程播放页面 - 播放缓冲超过5秒'
                })
              }
            }

            if (playLoadingSeconds === 15) {
              console.log('loading15秒')
              if (monitor) {
                monitor.stat({
                  logType: 'info',
                  title: '学院-错误日志',
                  message: JSON.stringify({
                    keshi_id: window.baseInfo.keshi_id,
                    session_id: window.baseInfo.user_id,
                    卡顿时间点: playTime
                  }),
                  level: 'error',
                  url: location.href,
                  payParameters: JSON.stringify({}),
                  code: '',
                  UA: navigator.userAgent,
                  remark: '课程播放页面 - 播放缓冲超过15秒'
                })
              }
            }
          }
        }, 1100)
      }

      async function postTime(cb, isPause = false) {
        setLocalLearnTime(isPause) // 每次更新记录的学习时长

        console.log('--postTime--')
        if (+window.baseInfo.user_id <= 0) {
          console.log('未登录，不保存进度')
          return
        }
        const _playTime =
          typeof player.j2s_getCurrentTime === 'function' &&
          player.j2s_getCurrentTime()
        playTime = _playTime || playTime // 以j2s_getCurrentTime为准。如果j2s_getCurrentTime获取不到。用原本的值
        console.log('_playTime', _playTime, playTime)
        console.log('learningTime 学习时长：', window.learnTotalTime)
        // if (typeof _playTime === 'number' && _playTime < playTime) {
        //   return
        // }
        try {
          const url =
            `${APIS.updatePlayTime}` +
            `?keshi_id=${
              window.baseInfo.keshi_id
            }&play_time=${playTime}&learningTime=${window.learnTotalTime || 0}`
          await $http.get(url)
        } catch (e) {
          // console.log(e);
        }

        cb && cb()
      }

      let timingEecords = null
      function startTimingEecords() {
        if (timingEecords) return
        timingEecords = setInterval(() => {
          postTime()
        }, 60000)
      }
      function closeTimingEecords() {
        clearInterval(timingEecords)
        timingEecords = null
      }
    })
    .catch(e => {
      onError()
    })
}

export default playInit



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/player/index.js